<template>
  <router-view></router-view>
</template>

<script>
  import store from '@/store/store'
  export default {
    async beforeRouteEnter (to, from, next) {
      try {
        await Promise.all([
          store.dispatch('resetArMeta'),
          store.dispatch('clearArState', true),
          store.dispatch('clearFilters')
        ])
      } catch (e) {
        console.log(e)
      }
      next()
    },
    async beforeRouteLeave (to, from, next) {
      try {
        await Promise.all([
          store.dispatch('resetArMeta'),
          store.dispatch('clearArState', true),
          store.dispatch('clearFilters')
        ])
      } catch (e) {
        console.log(e)
      }
      next()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/RouteComponents/Ars/Index.vue